import { render, staticRenderFns } from "./DrawAreaMobile.vue?vue&type=template&id=628b15a5&lang=pug"
import script from "./DrawAreaMobile.vue?vue&type=script&lang=js"
export * from "./DrawAreaMobile.vue?vue&type=script&lang=js"
import style0 from "./DrawAreaMobile.vue?vue&type=style&index=0&id=628b15a5&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports